import { useLocale } from "@/lib/i18n";

type Review = { title: string; text: string; author: string };

const reviewsDa: Review[] = [
  {
    title: "Smuk lampe og super service",
    text: "Lampen er endnu smukkere i virkeligheden. Hurtig levering og dejlig kommunikation hele vejen — kan varmt anbefales.",
    author: "Mette",
  },
  {
    title: "Kan klart anbefales",
    text: "Vi besøgte showroomet på Frederiksberg og blev mødt med stor varme og viden om Murano. Vi gik hjem med præcis den lampe, vi havde drømt om.",
    author: "Camilla",
  },
  {
    title: "Et lille stykke Italien",
    text: "Pakket flot ind, ankom uden en ridse. Det føles som at få et lille stykke Italien hjem i stuen. Tak for en super oplevelse.",
    author: "Anders",
  },
];

const reviewsEn: Review[] = [
  {
    title: "Beautiful lamp and great service",
    text: "Even more beautiful in person. Fast shipping and lovely communication throughout — highly recommended.",
    author: "Mette",
  },
  {
    title: "Can definitely recommend",
    text: "We visited the showroom in Frederiksberg and were met with warmth and deep Murano knowledge. We left with the exact lamp we had been dreaming of.",
    author: "Camilla",
  },
  {
    title: "A little piece of Italy",
    text: "Beautifully packed, arrived without a scratch. It feels like bringing a little piece of Italy into the living room.",
    author: "Anders",
  },
];

export function TrustpilotReviews() {
  const locale = useLocale();
  const reviews = locale === "da" ? reviewsDa : reviewsEn;
  const eyebrow = locale === "da" ? "Anmeldelser" : "Reviews";
  const title = locale === "da" ? "Hvad kunderne siger" : "What customers say";
  const sub =
    locale === "da"
      ? "4,7 ud af 5 · 74 anmeldelser · Fremragende"
      : "4.7 out of 5 · 74 reviews · Excellent";
  const seeAll = locale === "da" ? "Se alle anmeldelser" : "See all reviews";

  return (
    <section className="mx-auto max-w-[1500px] px-6 py-14 md:px-10 md:py-28">
      <div className="mb-12 flex flex-col items-center text-center md:mb-16">
        <p className="eyebrow text-terracotta">{eyebrow}</p>
        <h2 className="mt-4 font-display text-[clamp(2rem,4.5vw,3.6rem)] leading-[1.05]">
          {title}
        </h2>
        <div className="mt-5 flex items-center gap-3 text-sm text-foreground/70">
          <span className="text-lg tracking-widest text-[oklch(0.78_0.16_145)]">
            ★★★★★
          </span>
          <span>{sub}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
        {reviews.map((r) => (
          <article
            key={r.title}
            className="flex flex-col rounded-sm border border-border/60 bg-background p-7 md:p-8"
          >
            <div className="text-base tracking-widest text-[oklch(0.78_0.16_145)]">
              ★★★★★
            </div>
            <h3 className="mt-4 font-display text-xl leading-snug">{r.title}</h3>
            <p className="mt-4 flex-1 text-sm leading-relaxed text-muted-foreground">
              {r.text}
            </p>
            <div className="mt-6 flex items-center justify-between border-t border-border/50 pt-4 text-xs">
              <span className="font-medium text-foreground">{r.author}</span>
              <span className="uppercase tracking-[0.18em] text-muted-foreground">
                Trustpilot
              </span>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-12 flex justify-center">
        <a
          href="https://dk.trustpilot.com/review/farveladeland.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[11px] uppercase tracking-[0.28em] text-foreground/70 hover:text-terracotta"
        >
          {seeAll} →
        </a>
      </div>
    </section>
  );
}
